export const usersTableEn = {
  noUserFound: 'This user was not found'
}

export const usersTableRu: typeof usersTableEn = {
  noUserFound: 'Такой пользователь не найден'
}
